import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="0" y="15" rx="4" ry="4" width="70" height="6" />
      <rect x="75" y="15" rx="4" ry="4" width="2" height="6" />
      <rect x="80" y="15" rx="4" ry="4" width="70" height="6" />
      <rect x="0" y="25" rx="4" ry="4" width="200" height="6" />
      <rect x="0" y="35" rx="4" ry="4" width="250" height="6" />
      <rect x="0" y="45" rx="4" ry="4" width="250" height="6" />
      <rect x="0" y="55" rx="4" ry="4" width="250" height="6" />
    </React.Fragment>
  );
};
